export default "<p>safra-detalhe works!</p>\n"